import React, { useState, useEffect } from 'react';
import EarthAnimation from "../components/EarthAnimation";
import RocketAnimation from "../components/RocketAnimation";
import "./Hero.css";
import 'animate.css';

const phrases = [
  "software engineer",
  "tech enthusiast",
  "problem solver",
  "escape room enthusiast",
  "web developer",
  "lifelong learner",
  "numismatist",
  "traveller",
];

const Hero = () => {
  const [currentSection, setCurrentSection] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [phraseIndex, setPhraseIndex] = useState(0);

  const typingSpeed = 150;
  const deletingSpeed = 75;

  useEffect(() => {
    const sectionIntervalId = setInterval(() => {
      setCurrentSection((prev) => (prev + 1));
    }, 5 * 1000);

    return () => clearInterval(sectionIntervalId);
  }, []);

  useEffect(() => {
    const currentPhrase = phrases[phraseIndex];

    let timeout;
    if (!isDeleting) {
      if (displayText.length < currentPhrase.length) {
        timeout = setTimeout(() => {
          setDisplayText(currentPhrase.substring(0, displayText.length + 1));
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => setIsDeleting(true), 1000);
      }
    } else {
      if (displayText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayText(currentPhrase.substring(0, displayText.length - 1));
        }, deletingSpeed);
      } else {
        setIsDeleting(false);
        setPhraseIndex((prev) => (prev + 1) % phrases.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, phraseIndex]);

  return (
    <div className="landing-container">
      <EarthAnimation section={currentSection} />
      <RocketAnimation delay={3000} popupDelay={3500}/>
      <div className="text-container">
        <h1 className="animate__animated animate__fadeInDown">
          <span id="hero-firstname">Ayaan</span>
        </h1>
        <h2 className="animate__animated animate__fadeInUp">
          <span id="lastname">Nadamal</span>
        </h2>
        <div className="phrase-container">
          <p className="animate__animated animate__fadeInUp">I am a</p>
          <h3 className="animate__animated animate__fadeInUp">
            <span id="phrase">{displayText}</span>
          </h3>
        </div>
        <h4 className="animate__animated animate__fadeInUp">
          3rd year Computer Science <span id="uni">@UWaterloo</span>
        </h4>
      </div>
    </div>
  );
};

export default Hero;
